import SearchFilterInput from "../../form-fields/search-filter-input";
import SimpleButton from "../../buttons/Simple-button";
import H2 from "../../typography/H2";
import { FeedbackTypesEnum } from "@propertelligent/client-api";
import "./top-listing-headers.css";
import SingleDropdown from "../../singleDropdown/SingleDropdown";
import Chevren_downIcon from "../../../assets/svgs/Chevren_down";

interface FeedbackTopHeaderProps {
  className?: string;
  PageHeading?: string;
  Count?: number;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  activeFilter: string;
  setActiveFilter: (filter: string) => void;
  onAddClick?: () => void;
  aggregateValuesFilters?: Record<string, number> | null;
}

export default function FeedbackTopHeader({
  className = "",
  PageHeading = "Feedback",
  Count = 0,
  searchTerm,
  setSearchTerm,
  activeFilter,
  setActiveFilter,
  onAddClick,
  aggregateValuesFilters,
}: FeedbackTopHeaderProps) {
  const feedbackLabelToIdMap: Record<string, string> = {
    "Feature Requests": String(FeedbackTypesEnum.FeatureRequest),
    "Bug Reports": String(FeedbackTypesEnum.ReportBug),
    "Product Support": String(FeedbackTypesEnum.ProductSupport),
    "General": String(FeedbackTypesEnum.Other),
    "Data Requests": String(FeedbackTypesEnum.DataUpdateRequest),
    "Billing": String(FeedbackTypesEnum.BillingQuestion),
  };

  const filterOptions = [
    { title: "All", value: "All", count: Count },
    ...(aggregateValuesFilters
      ? Object.entries(aggregateValuesFilters)
          .map(([label, count]) => {
            const value = feedbackLabelToIdMap[label];
            return value
              ? { title: label, value, count }
              : null;
          })
          .filter(Boolean)
      : []),
  ] as { title: string; value: string; count: number }[];

  const activeFilterOption = filterOptions.find(opt => opt.value === activeFilter);
  const triggerText = activeFilterOption ? `${activeFilterOption.title} (${activeFilterOption.count})` : "All";

  return (
    <div className={`top-listing-header feedback-header ${className}`}>
      <div className="top-listing-header-top d-flex justify-content-between align-items-center mb-3">
        <h2 className="page-title mb-0">{PageHeading}</h2>
        {onAddClick && (
          <SimpleButton label="Add Feedback" onClick={onAddClick} />
        )}
      </div>

      <div className="top-listing-header-filters">
        <div className="filter-options filters-desktop">
          {filterOptions.map((option: any) => (
            <button
              key={option.value}
              className={`filter-option ${
                activeFilter === option.value ? "filter-option-active" : ""
              }`}
              onClick={() => setActiveFilter(option.value)}
            >
              {option.title} ({option.count})
            </button>
          ))}
        </div>

        <div className="search-sort-container" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <SearchFilterInput
            placeholder="Search feedback..."
            searchTerm={searchTerm}
            handleSearch={(e) => setSearchTerm(e.target.value)}
          />
          <div className="filters-mobile">
            <SingleDropdown
              key={triggerText}
              triggerText={triggerText}
              triggerIcon={<Chevren_downIcon width={"18"} height={"18"} />}
              triggerIconPosition="right"
              menuItems={filterOptions.map((option: any) => ({
                label: `${option.title} (${option.count})`,
                action: () => setActiveFilter(option.value),
              }))}
            />
          </div>
        </div>
      </div>
    </div>
  );
}